<template>
  <div>
    <head-nav
      style="position:absolute;left:50%;transform:translateX(-50%)"
      :activeNav="'libro'"
    ></head-nav>
    <!-- 头部图片banner -->
    <div class="banner">
      <h2>
        Libro de <br />
        reclamaciones
      </h2>
      <img src="../assets/image/bannerBook.png" alt="" />
    </div>
    <div class="content">
      <h2>Nuestro compromiso</h2>
      <p style="margin-bottom: 30px">
        En cumplimiento de la normativa legal vigente, atenderemos su queja o
        reclamo en un plazo no mayor a 15 días hábiles, contados a partir del
        día siguiente de recepcionada la Hoja de Reclamación.

        <span style="display:block;margin-top: 20px">
          Debe tener en cuenta que una vez recibida la queja o el reclamo,
          utilizaremos la información enviada por usted para iniciar las
          investigaciones correspondientes y, de ese modo, resolver su queja o
          reclamo en función de la naturaleza del problema y de la información
          facilitada. Mientras tanto, es posible que nos pongamos en contacto
          con usted para obtener información adicional que nos ayude a resolver
          el problema adecuadamente
        </span>
      </p>
      <h2>Cómo iniciar una reclamación</h2>
      <p style="margin-bottom: 60px">
        Para las quejas y/o reclamos sobre Muchamo, puede enviarlo descargando
        el libro de reclamación que se encuentra en el link inferior, el cual
        deberá indicar todos los datos requeridos en el formulario, así mismo le
        solicitamos que la información que nos detalle sea la más completa para
        poder ayudar a resolver su problema. Al finalizar el formulario deberá
        ser enviado al correo de atención al cliente:
        <span style="color:#768FF5">support@muchamo.com</span>
      </p>
      <div @click="downLoadFile" class="downloadBtn">
        <img src="../assets/image/downLoad.png" alt="" />
        <p>
          DESCARGA LIBRO <br />
          DE RECLAMACIONES
        </p>
      </div>
    </div>
    <foot-page></foot-page>
  </div>
</template>

<script>
import footPage from "../components/footPage.vue";
import headNav from "../components/headNav.vue";
export default {
  components: {
    headNav,
    footPage,
  },
  methods: {
    downLoadFile() {
      window.open(
        "https://prod-peru.obs.na-mexico-1.myhuaweicloud.com/libro_de_reclamaciones_Muchamo_1206.docx"
      );
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.banner {
  height: 413px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 75px;
  background: #03040c;
  h2 {
    font-size: 50px;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #ffffff;
    line-height: 58px;
    text-align: center;
    margin-right: 70px;
  }
}
.content {
  padding: 60px 20% 90px;
  background-color: #03040c;
  h2 {
    font-size: 50px;
    font-family: Roboto-Medium, Roboto;
    font-weight: 500;
    color: #fff;
    margin-bottom: 15px;
  }
  p {
    font-size: 32px;
    font-family: Roboto-Regular, Roboto;
    font-weight: 400;
    color: #fff;
  }
  .downloadBtn {
    cursor: pointer;
    width: 602px;
    height: 113px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    background: #c90000 linear-gradient(180deg, #7c47e9 0%, #5d52dd 100%);
    border-radius: 40px;
    padding-bottom: 7px;
    p {
      color: #fff;
    }
    img {
      width: 70px;
      height: 70px;
      margin-right: 16px;
    }
  }
}
</style>
